module.exports = __webpack_public_path__ + "media/alarm.965b614d.mp3";